/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { Element, ContentSection, Column, FooterSection, Row } from "trux"
import traceLogo from "../assets/trace-logo.svg"
import { parseQuery } from "../../../util/query"
import { webApi } from "../../../lib/WebApi"
import { useGetUserRelationsQuery } from "../../../generated/graphql"
import loadingSpinner from "../assets/loading-svg.svg"
import {
    addRelation,
    checkForEmail,
    emailSwitch,
    getUserInfo,
    loadUser,
} from "../actions"
import trace from "../../../reducers"

export const LoadingStep = (props) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [logoutStepDone, setLogoutStepDone] = useState(false)
    const [loginStepDone, setLoginStepDone] = useState(false)
    const searchParams = parseQuery(location.search)
    const userId = searchParams ? parseInt(searchParams["user_id"], 10) : null
    const token = searchParams ? parseInt(searchParams["token"], 10) : null

    useEffect(() => {
        console.log("props loggedin", props.isLoggedIn)
        if (props.isLoggedIn >= 0) {
            props.logInUser()
        }
    }, [props.isLoggedIn])

    return (
        <ContentSection>
            <Column center span="12" className="loading">
                <Element tag="img" src={loadingSpinner} />
            </Column>
            <Row center>
                <Element tag="img" src={traceLogo} className="trace-logo" />
            </Row>
        </ContentSection>
    )
}
